import { type ReactNode } from 'react';
import { messages } from '../i18n/messages.js';
import { useSession } from '../app/session-context.js';
import { ShopsPanel } from './ReferenceScreen.js';

/** Do'konlar — Toshkent va Urganch nuqtalari. */
export function ShopsScreen(): ReactNode {
  const { locale } = useSession();
  const t = messages(locale);

  return (
    <section className="adm-page">
      <header className="adm-page__header">
        <h1 className="adm-page__title">{t.refShops}</h1>
      </header>
      <ShopsPanel hideTitle />
    </section>
  );
}
